import { KB } from 'CorePackage/MainModule/constants/fileSize';

export const formatBytes = (bytes: number, decimals = 2) => {
  if (bytes === 0) {
    return '0 B';
  }

  const k = KB;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / k ** i).toFixed(dm)) + sizes[i];
};
